
const YouTubeEmbed = ({ embedUrl, page, mapSizeMod=0 }) => {
    let height = '100%';
    let className = 'dmVideoBackground';
    if(page === 'tvplayerView') {
        height =  (100 + parseInt(mapSizeMod)*5) + '%'
    }
    else if(page === 'playerView') {
        className = 'pvVideoBackground'
    }
    else if(page === 'showcaseView') {
        height = 'unset'
        className = 'showcaseVideo'
    }

    return (
        <iframe 
            height={height}
            className={className} 
            src={embedUrl} 
            title="DmBuddy YouTube Video Player" 
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; web-share" 
        />
    );
};

export default YouTubeEmbed;
